export function loadImage(url: string): Promise<string> {
	return fetch(url)
		.then((res) => res.blob())
		.then((blob) => URL.createObjectURL(blob))
}

export function getImageDimensions(imageFile: File): Promise<{ width: number; height: number }> {
	if ('createImageBitmap' in window) {
		return createImageBitmap(imageFile).then((bitmap) => {
			const dimensions = {
				width: bitmap.width,
				height: bitmap.height,
			}
			bitmap.close()
			return dimensions
		})
	}

	// Fallback for older browsers
	return new Promise((resolve, reject) => {
		const img = new Image()
		const url = URL.createObjectURL(imageFile)
		img.onload = () => {
			URL.revokeObjectURL(url)
			resolve({
				width: img.width,
				height: img.height,
			})
		}
		img.onerror = () => {
			URL.revokeObjectURL(url)
			reject(new Error('Failed to load image'))
		}
		img.src = url
	})
}

export function getVideoMetadata(
	videoFileOrURL: File | string
): Promise<{ width: number; height: number; duration: number; url: string }> {
	return new Promise((resolve, reject) => {
		const video = document.createElement('video')
		const url =
			typeof videoFileOrURL === 'string' ? videoFileOrURL : URL.createObjectURL(videoFileOrURL)

		video.preload = 'metadata'
		video.onloadedmetadata = () => {
			resolve({
				width: video.videoWidth,
				height: video.videoHeight,
				duration: video.duration,
				url,
			})
		}

		video.onerror = reject
		video.src = url
	})
}
